import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["value", "disabled"]
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, [
      (_ctx.fileDetail.file.type)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(`file-icon far fa-file ${_ctx.getFileIcon(_ctx.fileDetail.file.type)}`)
          }, null, 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("input", {
        type: "text",
        placeholder: "Enter Name",
        class: "form-control",
        value: _ctx.fileDetail.name,
        disabled: _ctx.uploading
      }, null, 8 /* PROPS */, _hoisted_1)
    ]),
    _createElementVNode("td", _hoisted_2, [
      _createVNode(_component_TypeaheadInput, {
        data: _ctx.searchedTypes,
        value: _ctx.selectedUploadType,
        onValueChanged: _ctx.uploadTypeChanged,
        placeholder: "Start Typing...",
        disabled: _ctx.uploading,
        showAllByDefault: true,
        openOnFocus: true,
        onBlurredInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.v$.fileDetails[_ctx.fileIndex].type.$touch()))
      }, null, 8 /* PROPS */, ["data", "value", "onValueChanged", "disabled"]),
      (_ctx.isFieldRequired(_ctx.fileIndex))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Type is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-xs btn-outline-danger",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeFile()))
      }, _hoisted_7)
    ])
  ]))
}